import React from "react";

export const ClockIcon = ({color="black", width="24", height="24"}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <path
        d="M21 3.9375C17.6254 3.9375 14.3265 4.9382 11.5206 6.81305C8.71468 8.6879 6.52773 11.3527 5.23631 14.4705C3.94489 17.5882 3.607 21.0189 4.26536 24.3287C4.92372 27.6385 6.54876 30.6788 8.935 33.065C11.3212 35.4512 14.3615 37.0763 17.6713 37.7346C20.9811 38.393 24.4118 38.0551 27.5295 36.7637C30.6473 35.4723 33.3121 33.2853 35.187 30.4794C37.0618 27.6735 38.0625 24.3746 38.0625 21C38.0577 16.4762 36.2585 12.1391 33.0597 8.94027C29.8609 5.74146 25.5238 3.94228 21 3.9375ZM30.1875 22.3125H21C20.6519 22.3125 20.3181 22.1742 20.0719 21.9281C19.8258 21.6819 19.6875 21.3481 19.6875 21V11.8125C19.6875 11.4644 19.8258 11.1306 20.0719 10.8844C20.3181 10.6383 20.6519 10.5 21 10.5C21.3481 10.5 21.6819 10.6383 21.9281 10.8844C22.1742 11.1306 22.3125 11.4644 22.3125 11.8125V19.6875H30.1875C30.5356 19.6875 30.8694 19.8258 31.1156 20.0719C31.3617 20.3181 31.5 20.6519 31.5 21C31.5 21.3481 31.3617 21.6819 31.1156 21.9281C30.8694 22.1742 30.5356 22.3125 30.1875 22.3125Z"
        fill={color}
      />
    </svg>
  );
};
